<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Deposit Date"
            label-for="deposit_date"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['created_at']"
                :opens="'right'"
                @update="updateDateRange('created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>
    <b-card
      no-body
    >
      <b-overlay
        :show="submitLoading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <div
          class="m-2"
        >
          <b-row
            cols="12"
            class="pt-1 pb-1"
          >
            <b-col
              class="justify-content-end"
            >
              <b-row
                class="d-flex align-items-center justify-content-end mr-1"
              >
                <b-col class="d-flex justify-content-start">
                  <div class="font-weight-bolder text-muted mobile-margin">
                    {{ `${depositSelected.length} record${depositSelected.length === 1 ? '':'s'}` }} selected
                  </div>
                </b-col>
                <b-col md="3">
                  <v-select
                    v-model="selectedRider"
                    :options="Rider"
                    :reduce="option => option.id"
                    label="first_name"
                    placeholder="Select Rider"
                    class="ml-1 mobile-margin"
                    @input="deselectAll()"
                  >
                    <template v-slot:option="option">
                      {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
                    </template>
                  </v-select>
                </b-col>
                <div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color-blur mobile-margin mr-2"
                    @click="loadBills"
                  >
                    Get Deposits
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color mobile-margin"
                    :disabled="depositSelected.length > 0 ? false : true"
                    @click="SubmitDeposit"
                  >
                    Submit
                  </b-button>
                </div>
                <div class="ml-1">
                  <ReportTableButtons
                    :items="items"
                    :json_fieldz="json_fields"
                    :name="`${downloadReportName} - Page ${page}.xls`"
                    :bulkname="`${downloadReportName}.xls`"
                    :fetch="fetchDataForRiderNoPagination"
                    @refresh="fetchDataForRider"
                  />
                </div>
              </b-row>
            </b-col>
          </b-row>
          <div>
            <b-row>
              <b-col md="12">
                <b-overlay
                  id="overlay-background"
                  blur="10px"
                  opacity="0.30"
                  rounded="sm"
                  variant="light"
                >
                  <b-table
                    :per-page="perPage"
                    :items="items"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    hover
                    responsive
                    striped
                    show-empty
                    class="table-responsive"
                    @sort-changed="sortChanged"
                  >
                    <template #empty>
                      <TableDataFetching
                        :rows="items"
                        :data-loading="dataLoading"
                      />
                    </template>
                    <template #head()="{ field }">
                      <div
                        class="sortable-header"
                      >
                        <span class="header-text">{{ field.label }}</span>
                        <feather-icon
                          v-if="field.sortable"
                          :icon="sort === field.key
                            ? 'ArrowUpIcon'
                            : 'ArrowDownIcon'"
                          size="14"
                        />
                      </div>
                    </template>
                    <template #head(id)>
                      <div class="d-flex align-items-start">
                        <div>
                          <b-form-checkbox
                            id="selectAllCheckbox"
                            v-model="selectAllCheckbox"
                            name="selectAllCheckbox"
                            @change="onClickSelectAllCheckbox()"
                          />
                        </div>
                      </div>
                    </template>
                    <template #cell(id)="data">
                      <div class="d-flex align-items-start">
                        <div>
                          <div class="font-weight-bolder">
                            <b-form-checkbox
                              v-model="depositSelected"
                              :value="data.item.ref_no"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(ref_no)="data">
                      <div class="d-flex align-items-center">
                        <b-avatar
                          :text="avatarText(data.item.ref_no)"
                          size="32"
                          variant="light-primary"
                        />
                        <div class="ml-1">
                          <div
                            class="font-weight-bolder text-primary"
                          >
                            {{ data.value }}
                          </div>
                          <div class="font-small-2">
                            {{ __dateTimeFormatter(data.item.created_at) }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(rider)="data">
                      <div class="d-flex align-items-center">
                        <div>
                          <div class="font-weight-bolder">
                            {{ data.item.rider ? data.item.rider.first_name : '---' }}
                          </div>
                          <div class="font-small-2">
                            {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(commission)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(depositable_amount)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(deposit_amount)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(expenses_total)="data">
                      <span>{{ __numberWithCommas(data.value, true) }}</span>
                    </template>
                    <template #cell(deposited_date)="data">
                      {{ __dateTimeFormatter(data.value) || '---' }}
                    </template>
                    <template #cell(approved_date)="data">
                      {{ __dateTimeFormatter(data.value) || '---' }}
                    </template>
                    <template #cell(finance_current_status.key)="data">
                      <finance-status-badge
                        :status-key="data.value"
                        :finance-status="statusOptions"
                      />
                    </template>
                  </b-table>
                </b-overlay>
                <div class="mx-2 mb-2">
                  <b-row
                    cols="12"
                  >
                    <b-col
                      class="d-flex align-items-center justify-content-sm-start"
                      md="3"
                    >
                      <label class="width-75">Per page</label>
                      <v-select
                        v-model="perPage"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="pageOptions"
                        :clearable="false"
                        class="per-page-selector d-inline-block width-100"
                      />
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                      class="d-flex align-items-center justify-content-sm-end"
                      md="9"
                    >
                      <span class="text-muted pagination-text mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                      <b-pagination
                        v-model="page"
                        :total-rows="(meta.total)? meta.total : 0"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text>
                          <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                          />
                        </template>
                        <template #next-text>
                          <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                          />
                        </template>
                      </b-pagination>

                    </b-col>

                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </div></b-overlay>
    </b-card>
    <commission-detail-modal ref="commission_detail_modal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BRow,
  VBModal,
  BButton,
  VBTooltip,
  BPagination,
  BFormCheckbox,
  BTable,
  BOverlay,
  BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import CommissionDetailModal from '@/components/FinanceModuleForms/InfoModals/CommissionDetailModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const RiderRepository = RepositoryFactory.get('rider')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCol,
    BFormGroup,
    BFormCheckbox,
    BRow,
    vSelect,
    BCard,
    BButton,
    BPagination,
    BTable,
    BOverlay,
    FilterCard,
    FinanceStatusBadge,
    AdvancedDateFilter,
    CommissionDetailModal,
    BAvatar,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, heightTransition, tableMixin],
  data() {
    return {
      avatarText,
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
      },
      statusOptions: [],
      selectedRider: '',
      Rider: [],
      depositSelected: [],
      ExpenceOptions: [],
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['Y', 'm', 'd'],
        },
      },
      loading: false,
      dataLoading: false,
      Expenceloading: false,
      submitLoading: false,
      sort: '',
      perPage: 10,
      pageOptions: [10, 20, 50],
      expenseType: [
        { name: 'Fuel', value: 'fuel' },
        { name: 'Food', value: 'food' },
      ],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      disabled: true,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id',
          label: '#',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'ref_no',
          label: 'REF No',
          thClass: 'text-center',
          sortable: true,
        },
        {
          key: 'rider',
          label: 'Rider',
          sortable: true,
        },
        {
          key: 'warehouse.name',
          label: 'Warehouse',
          sortable: true,
        },
        {
          key: 'depositable_amount',
          label: 'Collected COD',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'expenses_total',
          label: 'Expenses Total',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'commission',
          label: 'Commission',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'deposit_amount',
          label: 'Depositable Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'deposited_date',
          label: 'Deposited Date',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'approved_date',
          label: 'Approved Date',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'finance_current_status.key',
          label: 'Status',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
      ],
      items: [],
      json_fields: {
        'Ref No': 'ref_no',
        'Deposit Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Rider: {
          field: 'rider.first_name',
          callback: value => `"${value}"`,
        },
        'Rider Employee Id': {
          callback: value => `"${value.rider !== null ? `${value.rider.reference_id}` : 'N/A'}"`,
        },
        Warehouse: {
          field: 'warehouse.name',
          callback: value => `"${value}"`,
        },
        'Depositable Amount': 'depositable_amount',
        'Expenses Total': 'expenses_total',
        Commission: 'commission',
        'Deposit Amount': 'deposit_amount',
        'Deposited Date': {
          field: 'deposited_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Approved Date': {
          field: 'approved_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Status: 'finance_current_status.name',
      },
      errorCount: 0,
      selectAllCheckbox: false,
      downloadReportName: 'Rider-New-Commissions',
      pageWithSelectAll: [],
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForRider()
      },
    },
    deep: true,
    page() {
      this.fetchDataForRider()
    },
    perPage() {
      this.fetchDataForRider()
    },
    selectedRider: {
      async handler(val) {
        if (val === null) {
          this.clearDate('status_date')
          this.disabled = true
        }
      },
    },
  },
  mounted() {
    this.readDataforRider()
    this.statusOptions = JSON.parse(localStorage.getItem('finance_statuses'))
    this.updateFilterCount()
  },
  methods: {
    async readDataforRider() {
      try {
        this.Rider = localStorage.getItem('rider_list') ? JSON.parse(localStorage.getItem('rider_list')) : (await RiderRepository.getAllRiderDropDown()).data.data
        if (!localStorage.getItem('rider_list')) localStorage.setItem('rider_list', JSON.stringify(this.Rider))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async loadBills() {
      if (!this.selectedRider) {
        this.showErrorMessage('Please Select a Rider')
      } else {
        this.deselectAll()
        await this.fetchDataForRider()
      }
    },
    async fetchDataForRider() {
      this.dataLoading = true
      const isChecked = this.pageWithSelectAll.includes(this.page)
      if (!isChecked) {
        this.selectAllCheckbox = false
      } else {
        this.selectAllCheckbox = true
      }
      if (this.selectedRider !== '') {
        try {
          this.loading = true
          const filterQuery = this.buildFilterQuery()
          const { data } = (await FinanceRepository.getAllRiderDepositList(this.page, this.perPage, this.selectedRider, filterQuery))
          this.items = data.data
          this.meta = data.meta
          this.disabled = false
        } catch (e) {
          this.showErrorMessage('Sorry for the inconvenience! Please Try Again!!')
        }
      }
      this.loading = false
      this.dataLoading = false
    },
    async fetchDataForRiderNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getAllRiderDepositListNoPagination(this.selectedRider, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForRider()
    },
    applyFilters() {
      this.fetchDataForRider()
      this.deselectAll()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchDataForRider()
      })
      this.updateFilterCount()
    },
    selectAll() {
      this.depositSelected = this.items.map(n => n.ref_no)
    },
    deselectAll() {
      this.depositSelected = []
      this.selectAllCheckbox = false
      this.items = []
      this.meta = {}
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.depositSelected = [...this.depositSelected, ...this.items.map(n => n.ref_no)]
        this.pageWithSelectAll = [...this.pageWithSelectAll, this.page]
      } else {
        this.depositSelected = []
        this.pageWithSelectAll = []
      }
    },
    SubmitDeposit() {
      const deposit = {
        ref_numbers: this.depositSelected,
      }
      if (this.depositSelected.length === 0) {
        this.showErrorMessage('Please Select Deposits First')
      } else if (this.selectedRider !== this.items[0].rider.id) {
        this.showErrorMessage('Selected deposits do not match the selected rider')
      } else {
        this.handleSubmit(deposit)
      }
    },
    async handleSubmit(deposit) {
      this.$refs.commission_detail_modal.openModal(this.depositSelected, this.createDeposit, deposit, 'rider')
    },
    async createDeposit(deposit) {
      const res = await FinanceRepository.createRiderFinanceCommissionInvoice(deposit)
      if (res.status === 200) {
        this.showSuccessMessage('Data Added Successfully')
        await this.$router.push('/operations/rider-commission')
      } else {
        this.showErrorMessage('Cannot Add Commission Invoice')
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.custom-button-color-blur {
  background-color: #6da5ff !important;
  border-color: #6da5ff !important;
}
@media (max-width: 767px) {
  .table-responsive {
    position: sticky;
    top: 0;
  }
  .mobile-margin {
    margin-bottom: 20px;
    width: 100%;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
